import React, { useState } from "react";
import address from "../img/address.svg"
import calendar from "../img/calendar.svg"
import CircularProgress from '@mui/material/CircularProgress';
import Chip from '@mui/material/Chip';

import { Button } from "@material-ui/core";
import { style } from "@mui/system";
import { eventDatesFormatter } from "../utils/dates";

export default function JobCard(props) {
  let { job, jobsIsDisabled } = props;
  let [isClaiming, setIsClaiming] = useState(false);
  let venue = job.venue || {};
  let { name, city, state } = venue;

  let venueInfo = `${name} (${city}, ${state})`;

  function onClickHandle(job) {
    setIsClaiming(true);
    props.onClaimClick(job)
  }

  function createPlatformTag(platformBackgroundColor, platformBorder, platformColor, platformLabel) {
    return (
      <Chip 
        style={{backgroundColor:platformBackgroundColor, border:platformBorder, borderRadius:"0.5em", color:platformColor,fontWeight:"600"}} 
        label={platformLabel}
      />
    )
  }

  function displayPlatformName(primaryUrl) {

    if (primaryUrl != null) {

      const url = new URL(primaryUrl);
      const platformName = url.hostname.toLowerCase();

      if (platformName.includes("ticketmaster")) {
        return createPlatformTag("#026CDF", "", "#FFFFFF", "Ticketmaster");
      } 
      else if (platformName.includes("livenation")) {
        return createPlatformTag("#E21836", "", "#FFFFFF", "Live Nation");
      }
      else if (platformName.includes("axs")) {
          return createPlatformTag("#0054A1", "", "#FFFFFF", "AXS");
      }
      else if (platformName.includes("evenue")) {
        return createPlatformTag("#FF0000", "", "#FFFFFF", "eVenue");
      }
      else if (platformName.includes("mlb")) {
        return createPlatformTag("#002D72", "solid 2px #D50032", "#FFFFFF", "MLB");
      }
      else if (platformName.includes("etix")) {
        return createPlatformTag("#369FD9", "", "#FFFFFF", "etix");
      }
      else if (platformName.includes("ticketweb")) {
        return createPlatformTag("#7E4299", "", "#FFFFFF", "TicketWeb");
      }
      else if (platformName.includes("tixr")) {
        return createPlatformTag("#000000", "", "#FFFFFF", "TIXR");
      }
      else if (platformName.includes("seatgeek")) {
        return createPlatformTag("#FF5B49", "", "#FFFFFF", "SeatGeek");
      }
      else if (platformName.includes("seetickets")) {
        return createPlatformTag("#00999A", "", "#FFFFFF", "Seetickets");
      }
      else {
        return createPlatformTag("#FFFFFF", "solid 2px #F29B1B", "#F29B1B", "Venue Platform");
      }

    }

  }

  return (
    <div className={` job-card ${props.className}`}>
      <div className=" job-card-description-job-jacket">

        <div style={{display: 'flex', width: '100%'}}>
          <div>
            {displayPlatformName(job?.primaryUrl)}
          </div>
          <div className="job-card-id" style={{ marginLeft: 'auto' }}>
            ID: {job.id}
          </div>
        </div>

        <div>
          <h3> {job.name}</h3>
        </div>
        <div className="job-card-description-content">
          <img src={calendar} style={{ margin: '0 0.5em 0 0' }} height='24px' width='24px' alt="Calendar Icon" />
          <p className="job-card-description-text"> {eventDatesFormatter(job.date)}</p>
        </div>
        <div className="job-card-description-content">
          <img src={address} style={{ margin: '0 0.5em 0 0' }} height='24px' width='24px' alt="Location Icon" />
          <p className="job-card-description-text"> {venueInfo}</p>
        </div>
        <div>
        </div>
      </div>
      <div className=" job-card-actions ">

        <div className="job-card-actions-button-reward" >
        ${job.rewardAmt}
          {/* ${job.rewardAmt} <span style={{margin:'0 0 0 0.5em'}} id="jobPrice">{job.rewardType}</span>  commented for ticket BEE-611*/}
        </div>

        <Button
          variant="contained"
          style={jobsIsDisabled ? {
            width: '100%',
            height: '56px',
            backgroundColor: 'var(--grey-inactive)',
            borderRadius: '0.5em',
            color: 'white',
            fontSize: '1.25rem'
          } : {
            width: '100%',
            height: '56px',
            backgroundColor: 'var(--green)',
            borderRadius: '0.5em',
            color: 'white',
            fontSize: '1.25rem'
          }}
          disabled={jobsIsDisabled}
          onClick={() => onClickHandle(props.job)}
        >
          {
            isClaiming ?
              <CircularProgress style={{ padding: '8px', color: "white" }} />
              :
              jobsIsDisabled ? "UNAVAILABLE" : "CLAIM"
          }
        </Button>
      </div>
    </div >
  );
}
